
import { Vue, Component, Ref, Watch } from 'vue-property-decorator';
import lazyInject from '@/di';
import SupplyService from '@/services/supply.service';
import { CSupplierList } from '@/models/supply.model';
import EditSupplierModal from './components/EditSupplierModal.vue';

@Component({
  components: {
    EditSupplierModal,
  },
})
export default class SupplierManagement extends Vue {
  @lazyInject(SupplyService)
  supplyService!: SupplyService;

  @Ref('editSupplierModal')
  editSupplierModal!: EditSupplierModal;

  filterForm: any = {
    company_name: '',
    contact_name: '',
    contact_phone: '',
  };
  columns: any = [
    {
      title: '公司名称',
      dataIndex: 'companyName',
      align: 'center',
    },
    {
      title: '联系人',
      dataIndex: 'contactName',
      align: 'center',
    },
    {
      title: '电话',
      align: 'center',
      dataIndex: 'contactPhone',
    },
    {
      title: '状态',
      dataIndex: 'status',
      align: 'center',
      customRender: (text: any, record: any) => {
        return record.status === 1 ? '启用' : '暂停';
      },
    },
    {
      title: '操作',
      dataIndex: 'action',
      align: 'center',
      scopedSlots: { customRender: 'action' },
    },
  ];

  data: any[] = [];

  pagination: any = {
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: this.$store.state.pageSize.pageSize,
    showTotal: () => `共${this.pagination.total}条`,
    onChange: this.paginationChange,
    onShowSizeChange: this.onShowSizeChange,
  };

  @Watch('$route')
  async handleSearch() {
    const { company_name, contact_name, contact_phone, page, pageSize } =
      this.$route.query;
    const query: any = {
      page: page || 1,
      pageSize: pageSize || 10,
    };
    if (company_name) {
      query.company_name = company_name;
      this.filterForm.company_name = company_name;
    }
    if (contact_name) {
      query.contact_name = contact_name;
      this.filterForm.contact_name = contact_name;
    }
    if (contact_phone) {
      this.filterForm.contact_phone = contact_phone;
      query.contact_phone = contact_phone;
    }
    this.getSupplierList(query);
  }

  editSupplier(record: any) {
    this.editSupplierModal.open(record);
  }

  updateStatus(record: any) {
    this.$confirm({
      title: '提示',
      content: `确定要${record.status === 1 ? '暂停' : '启用'}吗？`,
      onOk: async () => {
        await this.supplyService.postSupplierUpdateStatus({
          id: record.id,
          status: record.status === 1 ? 2 : 1,
        });
        this.handleSearch();
      },
    });
  }

  search() {
    this.pagination.current = 1;
    this.getQueryParams();
  }

  resetQuery() {
    this.filterForm = {
      company_name: '',
      contact_name: '',
      contact_phone: '',
    };
    this.pagination.current = 1;
    this.getQueryParams();
  }

  getQueryParams() {
    const { company_name, contact_name, contact_phone } = this.filterForm;
    const { current, pageSize } = this.pagination;
    const query: any = {
      page: current,
      pageSize,
    };
    if (company_name) {
      query.company_name = company_name;
    }
    if (contact_name) {
      query.contact_name = contact_name;
    }
    if (contact_phone) {
      query.contact_phone = contact_phone;
    }
    query.timestamp = Math.round(Date.now() / 1000);
    this.$router.push({
      query,
    });
  }

  addSupplier() {
    this.editSupplierModal.open();
  }

  async getSupplierList(params: any) {
    const res: any = await this.supplyService.getSupplierList(params, this.$el);
    const list = (res && res.list) || [];
    this.data = list.map((item: any) => CSupplierList.from(item));
    this.pagination.total = (res && res.total) || 0;
    this.pagination.current = res.page;
    this.pagination.pageSize = res.pageSize;
  }

  paginationChange(page: number, pageSize: number) {
    this.pagination.current = page;
    this.pagination.pageSize = pageSize;
    this.getQueryParams();
  }

  onShowSizeChange(current: number, size: number) {
    this.pagination.current = 1;
    this.pagination.pageSize = size;
    this.getQueryParams();
  }

  mounted() {
    this.handleSearch();
  }
}
